import { usePolicyProductConfig } from '@folio/utils/usePolicyProductConfig';
import { Alert, AlertTitle } from '../../components/ui/alert';
import { Button, buttonVariants } from '../../components/ui/button';
import {
  branchDtoBranchStatusEnum,
  usePolicyControllerGeneratePolicySignatureRequest,
} from 'korint-sdk';
import { AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { CONTINUABLE_IN_QUOTE_FUNNEL } from '../PolicyWarningBanner/continuable-branches';

/**
 * @TODO This module was tested on GarantiePlus only.
 * Check later if it works on other products during Uniq Migration.
 * */
export function WarningBannerModule() {
  const { t } = useTranslation();
  const { policy, workingBranch } = usePolicyOnDashboard();

  const { mutateAsync: generatePolicySignatureRequest, isPending } =
    usePolicyControllerGeneratePolicySignatureRequest({
      mutation: {
        // biome-ignore lint/suspicious/noExplicitAny: typing problem for error
        retry: (failureCount: number, error: any) => {
          if (error.status !== 425 || failureCount >= 100) {
            // Only retry on 425
            return false;
          }

          return true;
        },
        retryDelay: () => 1000,
      },
    });

  const productCustomPath = usePolicyProductConfig('productCustomPath');

  return (
    <>
      {policy.status === 'POLICY_CONFIRMED' && (
        <Alert variant="info" className="flex justify-between items-center">
          <AlertTitle className="flex items-center gap-4 pt-1">
            <AlertCircleIcon />
            {t('warningBanner.quoteAwaitingSignature')}
          </AlertTitle>
          <Button
            loading={isPending}
            disabled={!workingBranch?.id}
            onClick={async () => {
              await generatePolicySignatureRequest({
                policyId: policy.id,
                data: { deliveryMode: 'EMAIL' },
                params: { branchId: workingBranch?.id! },
              });
            }}
          >
            {t('warningBanner.resendSignature')} <ChevronRightIcon className="h-4 w-4 ml-2" />
          </Button>
        </Alert>
      )}
      {(policy.status === 'POLICY_CREATED' || policy.status === 'POLICY_QUOTED') &&
        workingBranch?.branchStatus === branchDtoBranchStatusEnum.BRANCH_OPEN &&
        CONTINUABLE_IN_QUOTE_FUNNEL.includes(workingBranch.branchType ?? '') && (
          <Alert variant="info" className="flex justify-between items-center">
            <AlertTitle className="flex items-center gap-4 pt-1">
              <AlertCircleIcon />
              {t('warningBanner.quoteInProgress')}
            </AlertTitle>
            <Link
              to={`/discovery${productCustomPath}/${policy.customers[0]}/${policy.id}/${workingBranch?.id}/asset`}
              className={buttonVariants()}
            >
              {t('warningBanner.continueQuote')} <ChevronRightIcon className="h-4 w-4 ml-2" />
            </Link>
          </Alert>
        )}
    </>
  );
}
